import { lazy } from 'react';

const AuthenticationRouter = lazy(() => import('../views/auth/auth.router'));

export const AuthRouter = [
  {
    path: '/auth/*',
    name: 'auth',
    component: AuthenticationRouter,
  },
];
